import { internal, template } from '../../../vendor/elix.js';

function ButtonCtaMixin(Base) {

  return class ButtonCta extends Base {

      get [internal.template]() {

        return template.concat(

          super[internal.template],

          template.html`
            <style>
          
              #inner {
                background-color: var(--tp-button-cta-mixin-background-color);
              }

              #inner[disabled], #inner:disabled {
                color: var(--tp-button-cta-mixin-font-color-disabled);
                background-color: var(--tp-button-cta-mixin-background-color-disabled);
              }
      
              #inner:hover:enabled {
                background-color: var(--tp-button-cta-mixin-background-color-hover);
              }
    
              #inner:active:enabled,
              :host(:focus) #inner:enabled {
                background-color: var(--tp-button-cta-mixin-background-color-active);
              }
            </style>
          `
        );
      }
    }
  }

export default ButtonCtaMixin;
